import { IAppState } from '../../redux';

export function selectIsSinglePackage(state: IAppState): boolean {
  const { packageIds } = state.publishTerms;

  return packageIds.length === 1;
}
